// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_header--sticky.scss';

// -------------------------------------
// Variables
// -------------------------------------
let lastScrollTop = 0;

// Selectors
const HEADER_SELECTOR = '#shopify-section-header';
const THE_HEADER = '.header';
const ANNOUNCEMENT_BAR_SELECTOR = '.announcement-bar';
const STICKY_BAR_SELECTOR = '#js--sticky-bar';
const PRODUCT_SECTION = '.page-section--product';

// Classes
const HEADER_OPEN_CLASS  = 'js--is-open';
const STICKY_CLASS = 'is-sticky';
const ANNOUNCEMENT_BAR_HIDDEN_CLASS = 'announcement-bar--hidden';
const HEADER_HIDDEN_POSITION = '-500px';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('scroll', function() {
    const productSection = document.querySelector(PRODUCT_SECTION);
    const stickyBar = document.querySelector(STICKY_BAR_SELECTOR);
    
    if (productSection === null && stickyBar === null) {
        const headerSection = document.querySelector(HEADER_SELECTOR);
        const theHeader = document.querySelector(THE_HEADER);
        const announcementBar = document.querySelector(ANNOUNCEMENT_BAR_SELECTOR);
        const noScrollBody = document.querySelector('body.noscroll');
        let st = document.documentElement.scrollTop;

        if (headerSection) {
            if (st > lastScrollTop || st == 0) {
                if (noScrollBody) {
                    headerSection.style.top = '0';
                } else {
                    headerSection.style.top = HEADER_HIDDEN_POSITION;
                }

                if(!theHeader.classList.contains(HEADER_OPEN_CLASS)) {
                    headerSection.classList.remove(STICKY_CLASS);
                }

                if (announcementBar !== null) {
                    announcementBar.classList.remove(STICKY_CLASS);
                }
            } else if (st < lastScrollTop) {
                headerSection.classList.add(STICKY_CLASS);
                headerSection.style.top = '0';

                if (announcementBar !== null) {
                    announcementBar.classList.add(STICKY_CLASS);
                }
            }
            lastScrollTop = st <= 0 ? 0 : st;
        }
    }
});
